/**
 * 날짜 필터 URL 파라미터 파서.
 *
 * URL 쿼리 스트링에 수동/과거 주입된 날짜를 방어한다.
 * - 유효하지 않은 포맷은 null 반환
 * - 오늘보다 과거 날짜는 null 반환 (예약/조회 의미 없음)
 *
 * @param value "YYYY-MM-DD" 형식 문자열 또는 null
 * @returns 유효한 "YYYY-MM-DD" 문자열 또는 null
 */
export function parseFutureDateParam(value: string | null): string | null {
  if (!value) return null;

  const parsed = new Date(value + "T00:00:00");
  if (isNaN(parsed.getTime())) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return parsed >= today ? value : null;
}
